import actionCreatorFactory from "typescript-fsa";
import { BannerSearchRequestBody } from "../../core/api/requests/banner/search/types";
import { CommonAsyncType } from "../../core/types";
import { Banner } from "./types";

const actionCreator = actionCreatorFactory("@@Banner");

export const bannerActions = {
  getBanners: actionCreator.async<CommonAsyncType & BannerSearchRequestBody, Banner[]>("GET_BANNERS"),
  resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
};
